import Image from 'next/legacy/image';
import Script from 'next/script';
import React, { useEffect } from 'react';

import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';

const Reviews: React.FC = () => {
  const ReviewSetting = `window.__productReviewSettings = {
    brandId: '24eebc6d-a76f-34f8-b3d6-5d19b74338d1'
  };`;
  // useEffect used to load the ProductReview widget and ensure it is destroyed on unmount
  // This is to ensure the widget gets reinitialized correctly when navigating back to this page
  useEffect(() => {
    window.__productReviewCallbackQueue =
      window.__productReviewCallbackQueue || [];
    window.__productReviewCallbackQueue.push((ProductReview: any) => {
      ProductReview.use('reviews-horizontal', {
        identificationDetails: {
          type: 'single',
          strategy: 'from-internal-entry-id',
          identifier: 'a521e519-a98b-30c0-a226-6a8c6dfdffac',
        },
        container: '#pr-reviews-horizontal-widget',
        alias: 'reviews-page',
      });
    });

    return () => {
      window.__productReviewCallbackQueue =
        window.__productReviewCallbackQueue || [];
      window.__productReviewCallbackQueue.push((ProductReview: any) => {
        ProductReview.destroy('reviews-horizontal', {
          identificationDetails: {
            type: 'single',
            strategy: 'from-internal-entry-id',
            identifier: 'a521e519-a98b-30c0-a226-6a8c6dfdffac',
          },
          container: '#pr-reviews-horizontal-widget',
          alias: 'reviews-page',
        });
      });
    };
  }, []);
  return (
    <Main
      meta={
        <Meta
          title="My Muscle Chef Customer Reviews | #1 Food Delivery Service"
          description="Product Review's Top Rated Meal Delivery Service in Australia, 4 Years in a Row. See why our customers love our meals."
          canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/reviews-page`}
        />
      }
    >
      <div className="mx-auto font-inter">
        <div className="container mb-24 px-4 font-inter lg:px-16">
          <section className="my-12 flex flex-col items-center justify-between lg:flex-row lg:items-start">
            <div className="text-center lg:text-left">
              <h1 className="mb-4 mt-8 flex flex-col text-5xl leading-10 lg:mt-20 lg:text-8xl lg:leading-[58px]">
                <span>Taste,</span>
                <span>Convenience,</span>
                <span>Service</span>
              </h1>
              <p className="mb-8 max-w-[250px] leading-[22px] lg:mb-0 lg:max-w-[400px] lg:text-[26px] lg:leading-[34px]">
                Discover why our customers love My Muscle Chef.
              </p>
            </div>
            <Image
              src="/assets/images/jpg/reviews-banner.webp"
              alt="reviews-banner"
              width={812}
              height={541}
              className="rounded-2xl"
            />
          </section>
          <div id="pr-reviews-horizontal-widget"></div>
          <Script
            id="ReviewSetting"
            dangerouslySetInnerHTML={{ __html: ReviewSetting }}
          ></Script>
          <Script
            src="https://cdn.productreview.com.au/assets/widgets/loader.js"
            async
          ></Script>
        </div>
      </div>
    </Main>
  );
};

export default Reviews;
